import {WebCallService} from "@/utilities/services/WebCallService";
import {PathHelper} from "@/utilities/helpers/PathHelper";
import {ErrorLocationType, HttpType} from "@/utilities/enums/Enums";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {StartupConfigResponse} from "@/models/api/old/responses";
import {StartupConfig} from "@/models/StartupConfig";
import {useGlobalStore} from "@/stores/GlobalStore";
import {baseURL} from "@/AppConfig";

export class MiscService {
    private webCaller: WebCallService;
    private uriHelper: PathHelper;

    constructor(){
        // CAUTION -> doesnt initialize the AUTH service and therefore no token,
        // but since it is a singleton and gets initilized when calling other APIs
        // it shouldn't break for future APIs that need auth in this service
        this.webCaller = new WebCallService(false);
        this.uriHelper = new PathHelper();
    }

    public async setExternalCustomerLinks(errorLocationType:ErrorLocationType):Promise<boolean|null> {
        const uri = `${baseURL}/api/${this.uriHelper.misc.getStartupConfigPath()}`;

        const resp = await this.webCaller.getFromExternalAPI(uri);
        if (resp === null || resp === undefined || (resp.statusCode !== undefined && resp.statusCode !== 0)) {
            await ErrorHandler.handleOldError(resp, errorLocationType);
            return null;
        }

        (useGlobalStore()).settings.systemConfig = new StartupConfig(resp.data as StartupConfigResponse);

        return true;
    }
}
